import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {sequenceCardSchema} from '../../../../../schemas/sequenceCardSchema';
import {z} from 'zod';
import {
  DTSequenceNode,
  SequenceNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';

export function convertSequenceAPICardToAICard(sequenceCard: DTSequenceNode) {
  const candidate: z.input<typeof sequenceCardSchema> = {
    cardId: sequenceCard.id,
    name: sequenceCard.name ?? `Sequence #${sequenceCard.id}`,
    description: sequenceCard.description ?? '',
    type: NodeType.SEQUENCE,
    repeats: sequenceCard.outputs.map((output: SequenceNodeOutputData) => ({
      nodeId: output.nodeId ?? 0,
      id: output.id,
      name: output.name ?? '',
      type: output.type,
      timesToRepeat: output.maxRepeats ?? 1,
    })),
    numberOfTimesToRepeat: sequenceCard.maxRepeats ?? null,
  } satisfies z.output<typeof sequenceCardSchema>;

  return candidate;
}
